<template>
  <div class="p-4">
    <div class="d-flex align-items-center mb-3">
      <i class="fas fa-times-circle mr-2 text-orange"></i>
      <div class="color-gray-7 font-16 font-weight-bold">
        Razón de Rechazo
      </div>
    </div>
    <validation-observer ref="observer" novalidate>
      <validation-provider class="w-100" rules="required" v-slot="{ errors }">
        <div class="color-secondary-6 font-14 font-weight-normal mb-2">
          Comentario:
        </div>
        <custom-text-area
          v-model="model.comment"
          custom-error-msg="El campo Comentario es requerido"
          placeholder="Escriba un comentario"
          :maxlength="3000"
          :error="errors[0]"
        />
      </validation-provider>
    </validation-observer>

    <div class="d-flex justify-content-end mt-4">
      <action-button
        :variant="'outline-danger ' + (isMobile ? 'w-100  mt-4' : 'mr-2')"
        type="button"
        i="fas fa-times-circle"
        @click="cancel"
      >
        Cancelar
      </action-button>
      <action-button
        :variant="'success ' + (isMobile ? 'w-100  mt-4' : '')"
        type="button"
        i="fas fa-save"
        @click="save"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>
<script>
import mixAlert from '@/mixins/alert.mixin';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import service from '@/services/api/inventorycatalog.api';

export default {
  name: 'Rejection',
  components: {
    CustomTextArea,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        comment: null,
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async save() {
      try {
        const valid = await this.$refs.observer.validate();
        if (!valid) return;
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea rechazar la solicitud?`,
          'Sí',
          'No'
        );

        if (!confirmed) return;
        await service.rejectInventoryTransfer(this.item.id, this.model);
        this.ShowToast(
          'Éxito',
          'La transferencia se ha rechazada exitosamente.',
          'success'
        );
        this.$emit('refresh');
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
